import { round } from "lodash";
import { EField } from "../forms/createContract/schema.createContract.types";
import { getName } from "../redux/contact/contact.utils";
import { EContractMemberTypes, EContractStatus, ELeaseType, } from "../types/contract.types";
import { isAfter, isBefore, startOfDay, addMonths } from "./date-fns.utils";
import { getLocalizedText } from "./i18n/i18n.utils";
import { formatCurrency } from "./number.utils";
import { isFlemishZip } from "./property.utils";
import { getMembersWithRole } from "./roles.utils";
import { join } from "./string.utils";
export var STATUS_IS_ENDING_WHEN_IN_MONTHS = 9;
var FIRST_OF_JANUARY_2019 = "2019-01-01T00:00:00.000Z";
var NOW = new Date();
var START_OF_DAY = startOfDay(NOW);
var getContractStatus = function (contract) {
    if (!contract)
        return EContractStatus.NoContract;
    if (contract.stopDate && new Date(contract.stopDate) <= NOW)
        return EContractStatus.Finished;
    if (new Date(contract.startDate) > NOW)
        return EContractStatus.Upcoming;
    var isEnding = contract.stopDate &&
        new Date(contract.stopDate) >= NOW &&
        new Date(contract.stopDate) <=
            addMonths(START_OF_DAY, STATUS_IS_ENDING_WHEN_IN_MONTHS);
    return isEnding ? EContractStatus.Ending : EContractStatus.Running;
};
export var getContractAmountAndTenants = function (contract) {
    var total = (contract.currentCostsCommon || 0) +
        (contract.currentCostsNonCommon || 0) +
        (contract.currentPrice || 0);
    var amount = getLocalizedText("system.amount.".concat(contract.repetitionType).toLowerCase(), {
        amount: formatCurrency(round(total, 2)),
    });
    var tenants = join(getMembersWithRole(contract.members, EContractMemberTypes.Tenant).map(function (member) { return getName(member.account); }), " - ");
    return "".concat(amount, " - ").concat(tenants);
};
export var isResidentialLease = function (leaseType) {
    return [ELeaseType.StudentHousing, ELeaseType.MainResidence].includes(leaseType);
};
export var getShouldPrefillRefIndex = function (formData, property) {
    if (formData === void 0) { formData = {}; }
    var leaseType = formData[EField.LeaseType];
    var startDate = formData[EField.StartDate];
    var propertyInFlanders = (property === null || property === void 0 ? void 0 : property.zip) && isFlemishZip(property.zip);
    var residentialLease = isResidentialLease(leaseType);
    var contractStartedAfter2018 = isAfter(startDate, FIRST_OF_JANUARY_2019);
    return propertyInFlanders && residentialLease && contractStartedAfter2018;
};
export var isActiveContract = function (contract) {
    var startDate = contract.startDate, stopDate = contract.stopDate;
    if (!stopDate) {
        return false;
    }
    return isAfter(new Date(), startDate) && isBefore(new Date(), stopDate);
};
export var isEndedContract = function (contract) {
    var stopDate = contract.stopDate;
    if (!stopDate) {
        return false;
    }
    return isAfter(new Date(), stopDate);
};
export var isFutureContract = function (contract) {
    var startDate = contract.startDate;
    return isBefore(new Date(), startDate);
};
export var isEndingContract = function (contract) {
    return getContractStatus(contract) === EContractStatus.Ending;
};
export var isFinishedContract = function (contract) {
    return contract.stopDate && new Date(contract.stopDate) <= NOW;
};
export var isTerminatingContract = function (contract) {
    return !!contract.dateOfCancellation;
};
export var getIsShowExitChecklist = function (contract) {
    var contractIsEnding = isEndingContract(contract);
    var contractIsEnded = isEndedContract(contract);
    var contractIsFinished = isFinishedContract(contract);
    var contractIsTerminating = isTerminatingContract(contract);
    return (contractIsEnding ||
        contractIsEnded ||
        contractIsFinished ||
        contractIsTerminating);
};
